import shallow from 'zustand/shallow';
import PendingIcon from '@mui/icons-material/PendingOutlined';
import React from 'react';

import { useLoadingTileStore } from '../stores/useLoadingTilesStore';

export type SeismicNavbarLoadingIconProps = {
    show: boolean,
    fontSize?:  'medium' | 'small' | 'inherit' | 'large',
};

export const SeismicNavbarLoadingIcon = ({show, fontSize = 'medium'} : SeismicNavbarLoadingIconProps) => {

    const { loadingTiles } = useLoadingTileStore(state => ({
        loadingTiles: state.loading
    }));

    return (
        <React.Fragment>
            {
                (loadingTiles > 0 || show)
                &&
                <div className='container-loading'>
                    <PendingIcon fontSize={fontSize}/>
                </div>
            }
        </React.Fragment>
    );
};